export default __webpack_public_path__ + "static/media/book.ca129273.svg";